export type FlowStep = 'ConnectWallet' | 'DepositCode' | 'DepositConfirm' | 'DepositWrappingInfo'

export const STEP_CONNECT_WALLET: FlowStep = 'ConnectWallet'
export const STEP_QR_CODE: FlowStep = 'DepositCode'
export const STEP_CONFIRM: FlowStep = 'DepositConfirm'
export const STEP_WRAPPING_INFO: FlowStep = 'DepositWrappingInfo'
